<style scoped>
h1 {
  font-size: 5em;
}
.container {
  padding-top: 64px;
  padding-bottom: 64px;
}
</style>

<template lang="pug">
  .container.light-gray.text-center
    h1 Uh-Oh!
    h1 
        small.text-muted &nbsp;&nbsp; Page Not Found
    p Sorry but we can't find what you're looking for
</template>
<script>
export default {
  meta: {
    title: 'Page not found'
  }
}
</script>


// WEBPACK FOOTER //
// src/components/page-404.vue